'use strict';

exports.pbkdf2 = require('./lib/async');
exports.pbkdf2Sync = require('./lib/sync');



//////////////////
// WEBPACK FOOTER
// ./~/pbkdf2/browser.js
// module id = 673
// module chunks = 1